import { BehaviorSubject, Observable, Subject, filter, map, takeUntil } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { OccEndpointsService } from '@spartacus/core';

import { FaqNotUsefulReason } from '../models';

@Injectable({
  providedIn: 'root'
})
export class FaqService implements OnDestroy {
  private faqsNotUsefulReasons$ = new BehaviorSubject<FaqNotUsefulReason[]>(undefined);
  private isFaqsLoading: boolean;
  protected readonly destroy$: Subject<void> = new Subject();

  constructor(private occEndpointsService: OccEndpointsService, private http: HttpClient) {}

  getFaqsNotUsefulReasons(): Observable<FaqNotUsefulReason[]> {
    if (!this.isFaqsLoading && this.faqsNotUsefulReasons$.getValue() === undefined) {
      this.isFaqsLoading = true;

      const url = this.occEndpointsService.buildUrl('faqsNotUsefulReasons');
      this.http
        .get<{ FAQNotUsefulReasonList: FaqNotUsefulReason[] }>(url)
        .pipe(
          map(({ FAQNotUsefulReasonList }) => FAQNotUsefulReasonList),
          takeUntil(this.destroy$)
        )
        .subscribe((faqs) => {
          this.isFaqsLoading = false;
          this.faqsNotUsefulReasons$.next(faqs);
        });
    }
    return this.faqsNotUsefulReasons$.pipe(filter((faqs) => !!faqs));
  }

  voteForFaq(faqCode: string, isUseful: boolean, notUsefulReasonId?: string): Observable<void> {
    const params = { isUseful: String(isUseful) };
    if (notUsefulReasonId) {
      params['notUsefulReasonId'] = notUsefulReasonId;
    }
    const url = this.occEndpointsService.buildUrl('faqsVote', { urlParams: { faqCode }, queryParams: params });
    return this.http.put<void>(url, undefined);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
